import { FC } from 'react';
import { FooterProps } from '../Footer';
import { GettingStartedFooter } from '../../Layouts/GettingStartedLayout/GettingStartedFooter';

export const GettingStartedTooMuchOnPlateFooter: FC<FooterProps> = props => (
  <GettingStartedFooter {...props} icon="dishes" text="Too much on your plate? Take cooking off it." />
);
